import { memo } from "react";

import { BasicInfoLabelWithTextLayout } from "../../layout";

type Props = {
	reservationID: string;
};

export const ReservationIDOfBasicInfoCompositions = memo(({ reservationID }: Props) => {
	return (
		<BasicInfoLabelWithTextLayout
			isCol
			label="予約番号"
			textChildren={<p className="text-xl font-extrabold tracking-wider">{reservationID}</p>}
		/>
	);
});
